import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ProductLoginComponent } from './product-login/product-login.component';
import { LoginPageGuard } from '../core/services/login-page-guard.service';
import { GenericTitleResolver } from '../shared/generic-title-resolver.service';
import { ReturnUrlGuard } from '../core/services/return-url-guard.service';

export const loginRoutes: Routes = [
  {
    path: '',
    component: ProductLoginComponent,
    canActivate: [LoginPageGuard, ReturnUrlGuard],
    data: {
      genericTitle: 'Sign-In – DRC INSIGHT'
    },
    resolve: {
      title: GenericTitleResolver
    }
  },
  {
    path: ':productCode',
    component: ProductLoginComponent,
    canActivate: [LoginPageGuard, ReturnUrlGuard],
    data: {
      genericTitle: 'Sign-In – DRC INSIGHT'
    },
    resolve: {
      title: GenericTitleResolver
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(loginRoutes)
  ],
  exports: [RouterModule],
})
export class LoginRoutingModule {
}
